import { render, staticRenderFns } from "./GiveGift.vue?vue&type=template&id=0c6fef1b&scoped=true"
import script from "./GiveGift.vue?vue&type=script&lang=js"
export * from "./GiveGift.vue?vue&type=script&lang=js"
import style0 from "./GiveGift.vue?vue&type=style&index=0&id=0c6fef1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6fef1b",
  null
  
)

export default component.exports